import React from "react";
import { PracticeArea } from "../data/practiceAreas";
import { PillButton } from "./PillButton";
export function ServiceCard({
  area
}: {
  area: PracticeArea;
}) {
  const Icon = area.icon;
  return <article className="group relative h-[440px] w-[330px] shrink-0 snap-start overflow-hidden rounded-2xl bg-ink" data-id="element-293" data-mp="2qjytminukox9">
      <img src={area.image} alt="" className="absolute inset-0 h-full w-full object-cover saturate-[0.85] transition-transform duration-300 ease-out group-hover:scale-[1.02]" data-id="element-294" data-mp="2vkcu9fn4cwl9" />
      <div aria-hidden="true" className="absolute inset-0 bg-ink/45" data-id="element-295" data-mp="34ioodrn72cig" />

      <div className="relative flex h-full flex-col p-5" data-id="element-296" data-mp="39a7wzvvdemqj">
        <div className="flex items-start justify-between" data-id="element-297" data-mp="39csw4d4aaokl">
          <span className="rounded-full bg-ink/60 px-3 py-1 text-[11px] font-medium text-white/85" data-id="element-298" data-mp="3e8hpfyppn98g">
            {area.tag}
          </span>
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-white text-ink" data-id="element-299" data-mp="3j72qg0csdwxy">
            <Icon className="h-[18px] w-[18px]" strokeWidth={1.5} aria-hidden="true" data-id="element-300" data-mp="3o5mbzzngx6ps" />
          </span>
        </div>

        <div className="mt-auto" data-id="element-301" data-mp="1zayzf94inlzn">
          <h3 className="text-[24px] font-semibold tracking-[-0.02em] text-white" data-id="element-302" data-mp="1z9xp56vbr3iz">{area.title}</h3>
          <p className="mt-2 text-[14px] leading-[1.55] text-white/75" data-id="element-303" data-mp="1ucdzlat6f4bq">{area.description}</p>
          <div className="mt-5" data-id="element-304" data-mp="1qb2hdqcmtldk">
            <PillButton href="#contact" variant="white" size="sm" data-id="element-305" data-mp="1qbu5yh7taiuc">
              Learn more
            </PillButton>
          </div>
        </div>
      </div>
    </article>;
}